var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalsw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_332_21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6215 18.6308 24 11.994 24C5.35725 24 0 18.6215 0 12C0 5.37849 5.36921 0 12.006 0C12.9746 0 13.9073 0.119522 14.8042 0.334661"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12C25.5 11.1716 24.8284 10.5 24 10.5C23.1716 10.5 22.5 11.1716 22.5 12H25.5ZM14.4543 1.79328C15.2599 1.98652 16.0696 1.49013 16.2628 0.684556C16.456 -0.121018 15.9597 -0.930718 15.1541 -1.12396L14.4543 1.79328ZM22.5 12C22.5 17.7934 17.8021 22.5 11.994 22.5V25.5C19.4595 25.5 25.5 19.4497 25.5 12H22.5ZM11.994 22.5C6.18789 22.5 1.5 17.7953 1.5 12H-1.5C-1.5 19.4477 4.52661 25.5 11.994 25.5V22.5ZM1.5 12C1.5 6.20664 6.1979 1.5 12.006 1.5V-1.5C4.54051 -1.5 -1.5 4.55033 -1.5 12H1.5ZM12.006 1.5C12.8499 1.5 13.6652 1.604 14.4543 1.79328L15.1541 -1.12396C14.1494 -1.36496 13.0992 -1.5 12.006 -1.5V1.5Z",
    fill: "white",
    mask: "url(#path-1-inside-1_332_21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96863 11.3549L12.5561 14.9405L23.8087 3.58594",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalsw);
export default __webpack_public_path__ + "static/media/Approvalsw.585e1acf24a79aa4a2f2055a4418641d.svg";
export { ForwardRef as ReactComponent };